import { z } from "zod"

const operatingPreferenceEnum = z.enum([
  "passive",
  "active",
  "operational",
  "heavy-execution",
  "light-active",
  "high-operational",
])

const strategyEnum = z.enum([
  "brrr",
  "flips",
  "hmo",
  "sa",
  "cowork-serviced-office",
  "commercial-conversion",
  "urban-goldmine",
  "pure-commercial",
])

export const strategySchema = z.object({
  operatingPreference: operatingPreferenceEnum,
  primaryStrategy: strategyEnum,
  secondaryStrategy: z.union([strategyEnum, z.null()]).optional().default(null),
}).refine((v) => v.secondaryStrategy == null || v.secondaryStrategy !== v.primaryStrategy, {
  message: "Secondary strategy must differ from primary",
  path: ["secondaryStrategy"],
})
